import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-askleave",
  "use": "icon-askleave-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-askleave\">\n  <rect x=\"20\" y=\"25\" width=\"88\" height=\"78\" rx=\"8\" fill=\"currentColor\" opacity=\"0.3\" />\n  <rect x=\"20\" y=\"25\" width=\"88\" height=\"15\" rx=\"8\" fill=\"currentColor\" opacity=\"0.8\" />\n  <circle cx=\"64\" cy=\"64\" r=\"20\" fill=\"currentColor\" opacity=\"0.6\" />\n  <text x=\"64\" y=\"72\" text-anchor=\"middle\" font-size=\"20\" fill=\"white\">假</text>\n  <circle cx=\"90\" cy=\"40\" r=\"8\" fill=\"red\" opacity=\"0.8\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol